export default __webpack_public_path__ + "static/media/11.92a12371.png";